var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 -8.74228e-07C15.523 -3.91392e-07 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 3.91392e-07 15.523 8.74228e-07 10C1.35706e-06 4.477 4.477 -1.35706e-06 10 -8.74228e-07ZM9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14ZM10 12C9.44772 12 9 11.5523 9 11L9 6C9 5.44771 9.44772 5 10 5C10.5523 5 11 5.44771 11 6L11 11C11 11.5523 10.5523 12 10 12Z",
    fill: "#FF5630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamationMark.6e648164cd0e5330ffcc46084e9efd50.svg";
export { ForwardRef as ReactComponent };